import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import MediaQuery from 'react-responsive';
import * as jobActions from '../../actions/jobActions';
import {bindActionCreators} from 'redux';
import JobsList from './JobsList';
import JobsListDivs from './JobsListDivs';
import CustomModal from '../../components/CustomModal.jsx';
import CustomPagination from '../../components/common/CustomPagination.jsx';
import BaseList from '../../components/common/list/BaseList.jsx';
import { injectIntl } from 'react-intl';
import {messages} from  '../common/Translations';
import WithResolvedPromises from "../common/WithResolvedPromises";
import PlaceholderTable from "../common/PlaceholderTable";
import PlaceholderError from "../common/PlaceholderError";

class JobsPage extends BaseList {
    constructor(props) {
        super(props);

        this.listId = 'jobs';
        this.state = {
            page: 1,
            modalOpened: false,
            actions: this.getRequiredActions()
        };

        // set page from url
        if(props.match.params.page) {
            this.state.page = props.match.params.page;
        }

    }


    getRequiredActions() {
        return [
            this.props.actions.loadJobs(1)
        ];
    }

    componentWillUpdate(nextProps, nextState){
        if(this.sortParamWasChanged(nextProps)) {
            nextState.page = 1;
        }
    }

    cloneJob(e) {
        const jobId = e.target.closest('.job-item').getAttribute('data-job-id');
        this.props.actions.cloneJob(jobId, this.state.page);
    }

    showJobDeleteModal(e) {
        this.idToDelete = e.target.closest('.job-item').getAttribute('data-job-id');
        this.props.actions.showJobDeleteModal();
    }

    deleteJob(e) {
        if(!this.idToDelete) {
            console.log('Error');
            return;
        }

        this.props.actions.deleteJob(this.idToDelete, this.state.page);
        this.props.actions.hideJobDeleteModal();
    }

    onPageChange(addActions, pageNum) {
        let page = pageNum.selected + 1;
        let promise = this.props.actions.loadJobs(page, this.getSortParams(this.props));
        addActions([promise]);
        this.setState({page: pageNum.selected + 1});
    }

    render() {
        let {jobs} = this.props;
        return (
            <WithResolvedPromises promises={this.state.actions} preloaderComponent={PlaceholderTable}  errorComponent={PlaceholderError}>
                {
                    addActions => {
                        return (
                            <div>
                                <div className="row">
                                    <div className="col-12">
                                        <div className="card">
                                            <div className="card-block">
                                                <div className="row">
                                                    <div className="col-sm-6">
                                                        <h1 className="mb-3">
                                                            {this.props.intl.formatMessage(messages.jobListTitle)}
                                                        </h1>
                                                    </div>
                                                    <div className="col-sm-6 pt-2">
                                                        <Link className={'btn btn-primary waves-effect pull-right list-create-button'}
                                                              to="/jobopslag/skab"
                                                        >
                                                            {this.props.intl.formatMessage(messages.jobCreate)}
                                                        </Link>
                                                    </div>
                                                </div>
                                                <MediaQuery query='(max-device-width: 768px)'>
                                                    <JobsListDivs
                                                        jobs={jobs.items}
                                                        cloneJob={this.cloneJob.bind(this)}
                                                        showJobDeleteModal={this.showJobDeleteModal.bind(this)}
                                                    />
                                                </MediaQuery>
                                                <MediaQuery query='(min-device-width: 769px)'>
                                                    <JobsList
                                                        listId={this.listId}
                                                        jobs={jobs.items}
                                                        cloneJob={this.cloneJob.bind(this)}
                                                        showJobDeleteModal={this.showJobDeleteModal.bind(this)}
                                                    />
                                                </MediaQuery>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <CustomPagination
                                        total={jobs.total}
                                        page={this.state.page}
                                        onPageChange={this.onPageChange.bind(this, addActions)}
                                    />
                                </div>
                                <CustomModal
                                    modalTitle={this.props.intl.formatMessage(messages.jobDeleteModalTitle)}
                                    modalContent={<p>{this.props.intl.formatMessage(messages.jobDeleteQuestion)}</p>}
                                    confirmText={this.props.intl.formatMessage(messages.deleteModalConfirmButton)}
                                    closeText={this.props.intl.formatMessage(messages.deleteModalCancelButton)}
                                    handleConfirm={this.deleteJob.bind(this)}
                                    handleHideModal={this.props.actions.hideJobDeleteModal}
                                    isOpen={this.props.showJobDeleteModal}
                                />
                            </div>
                        );
                    }
                }
            </WithResolvedPromises>
        )
    }
}


function mapStateToProps(state, ownProps) {
    return {
        jobs: state.jobs || [],
        showJobDeleteModal: state.showJobDeleteModal,
        sortableList: state.sortableList,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(jobActions, dispatch)
    }
}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(JobsPage));


// WEBPACK FOOTER //
// ./web/src/components/jobs/JobsPage.jsx